import axios from "axios";
import { ApiResponse } from "./models";

const httpClient = axios.create({ baseURL: "/api/govpicidadao-middleware" });

export class NotaPiauienseService {
  static async listNotas(accessToken: string) {
    const { data } = await httpClient.get<ApiResponse>(
      "/sefaz/nota-piauiense/lista-notas",
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return data;
  }
}
